/**
 * Numeric range clamping. Pure-leaf module: NO value imports.
 */

/**
 * @runtime-derived-ssot-helper (const-leaf-pinned): generic helper homed in const/ so pure utils/ leaves can
 * value-import it without a forbidden cross-utils sibling dependency. Constrain `value` to the inclusive
 * [`min`, `max`] range. `max` wins when the bounds are inverted, and a NaN `value` propagates as NaN.
 */
export function clamp(value: number, min: number, max: number): number {
	return Math.min(Math.max(value, min), max);
}
